
































import InputPhoneInternational from '@/app/ui/components/InputPhoneInternational/index.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'


@Component({
  inheritAttrs: false,
  components: { InputPhoneInternational },
})
export default class MarketplaceTextInput extends Vue {
  @Prop({ required: true }) private fieldLabel!: string
  @Prop() private fieldDescription!: string
  @Prop() private fieldSuffix!: string
  @Prop() private errorMessage!: string
  @Prop({ default: false }) private required!: boolean
  @Prop({ default: '' }) private customClass!: string
  @Prop({ default: false }) private disabled!: boolean
}
